export const products = {
  all_products: "products/store/site/",
  single_product: (id: number) => `products/store/site/get-by/?id=${id}`,
  get_categories: "products/category/",
  get_categories_attribute: "products/category/attribute/",
  get_brands: "products/brand/",
  get_currency: "products/currency/site/",
  get_all_stores: "accounts/store/",
  get_all_stores_products: "products/all/store/",
  get_products_in_store: (id: number) => `products/store/site/by/?id=${id}`,
  get_all_basket: (currency_id: number) =>
    `products/basket/?currency_id=${currency_id}`,
  get_basket_delivery: (currency_id: number) =>
    `products/basket/delivery/?currency_id=${currency_id}`,
  get_delivery_settings: (currency_id: number) =>
    `products/delivery/?currency_id=${currency_id}`,
  get_installment_banks: "products/installment-banks/",
  update_basket: "products/basket/",
  update_basket_auth: (currency_id: number) =>
    `products/basket/?currency_id=${currency_id}`,
  remove_basket: "products/basket/",
  clear_basket: "products/basket/",
  get_all_wishlist: (currency_id: number) =>
    `products/wishlist/?currency_id=${currency_id}`,
  remove_add_wishlist: "products/wishlist/",
  filter: (category_id: number) =>
    `products/filter/?category_id=${category_id}`,
  search: "products/search/",
  complete_order: "products/payment/",
  complete_order_widget: "products/payment/widget/",
  my_orders: "products/order/user/",
};
